// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f9798ad6","453":"e4f1ba48","732":"657ebde8"}[chunkId] + ".chunk.js";
};